import Publication from './Components/Publication'

const ready = (callback) => {
  if (document.readyState !== 'loading') callback()
  else document.addEventListener('DOMContentLoaded', callback)
}

ready(() => {
  const publication = new Publication()
  publication.init()
})
